import { apiClient } from '../client';

/**
 * The organisation's do-not-call list, by number (W4, B2-settings-blacklist).
 * Admins only. Codes: docs/api/errors.md, « Liste noire ».
 */

export interface BlacklistContact { id: string; name: string; company: string; customer_id: string }

export interface BlacklistEntry {
  phone: string;
  phone_key: string;
  manual: boolean;
  reason: string;
  blocked_at: string | null;
  blocked_by: string | null;
  contacts: BlacklistContact[];
}

export interface BlacklistJournalEntry {
  action: 'blacklist.add' | 'blacklist.remove';
  actor_email: string;
  phone: string;
  reason: string;
  contacts: number;
  created_date: string;
}

export function listBlacklist(params: { q?: string; limit?: number } = {}, signal?: AbortSignal) {
  return apiClient.get<{ items: BlacklistEntry[]; total: number; truncated: boolean }>('/blacklist', { query: { q: params.q || undefined, limit: params.limit }, signal });
}

export function addToBlacklist(body: { phone: string; reason?: string }) {
  return apiClient.post<{ phone: string; phone_key: string; blocked_contacts: number }>('/blacklist', body);
}

export function removeFromBlacklist(body: { phone?: string; contact_id?: string; reason?: string }) {
  return apiClient.post<{ phone: string; unblocked_contacts: number }>('/blacklist/remove', body);
}

export function blacklistJournal(signal?: AbortSignal) {
  return apiClient.get<{ items: BlacklistJournalEntry[] }>('/blacklist/journal', { signal });
}
